import { IMilestoneTemplate } from "@/interfaces";
import { Form, Input, Modal } from "antd";
import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";

interface IProps {
  modalOpen: boolean;
  milestoneTemplate?: IMilestoneTemplate;
  onClose: React.MouseEventHandler;
  onOk: (milestoneTemplate: IMilestoneTemplate) => void;
}

export const MilestoneNameEditModal = ({
  modalOpen,
  milestoneTemplate,
  onClose,
  onOk,
}: IProps) => {
  const intl = useIntl();
  const [form] = Form.useForm();

  if (!milestoneTemplate) {
    return <Form form={form} component={false} />;
  }

  return (
    <Modal
      title={milestoneTemplate.name}
      centered
      open={modalOpen}
      onCancel={onClose}
      onOk={(): void => {
        const { name, abbreviation } = form.getFieldsValue();

        const updatedMilestone = _.cloneDeep(milestoneTemplate);

        updatedMilestone.name = name;
        updatedMilestone.abbreviation = abbreviation;

        onOk(updatedMilestone);
      }}
      okText={intl.formatMessage({ id: "general.ok" })}
    >
      <Form
        form={form}
        initialValues={{
          name: milestoneTemplate.name,
          abbreviation: milestoneTemplate.abbreviation,
        }}
        layout="vertical"
      >
        <Form.Item
          name="name"
          label={intl.formatMessage({ id: "milestoneTemplates.nameLabel" })}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="abbreviation"
          label={intl.formatMessage({
            id: "milestoneTemplates.abbreviationLabel",
          })}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
